import React from "react";
import { motion } from "framer-motion";
import { Megaphone, TrendingUp, Mic2, CalendarCheck, Clapperboard, Compass } from "lucide-react";
import { SERVICES } from "@/data/content";

const ICONS = [Megaphone, TrendingUp, Mic2, CalendarCheck, Clapperboard, Compass];

export const Services = () => {
  return (
    <section id="servicios" className="py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-2xl">
            <span className="text-xs font-semibold tracking-[0.25em] uppercase text-[#ff5c49]">
              Qué hacemos por ti
            </span>
            <h2 className="font-display text-4xl md:text-5xl font-extrabold tracking-tight mt-4 leading-tight">
              Servicios a tu medida
            </h2>
          </div>
          <p className="text-[#6b6873] md:text-right md:max-w-xs leading-relaxed">
            Soluciones flexibles, solas o combinadas, según tu momento y tus objetivos.
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
                data-testid={`service-card-${i}`}
                className="group bg-white border border-[#e4dccf] rounded-2xl p-8 hover:-translate-y-1.5 hover:shadow-xl hover:shadow-[#2b2a33]/5 transition-all duration-300"
              >
                <div className="flex items-center justify-between">
                  <div className="w-12 h-12 rounded-xl bg-[#fbf2ec] flex items-center justify-center group-hover:bg-[#ff5c49] transition-colors">
                    <Icon className="w-6 h-6 text-[#ff5c49] group-hover:text-white transition-colors" />
                  </div>
                  <span className="text-[11px] font-bold tracking-widest uppercase text-[#bcb4a6]">
                    {s.tag}
                  </span>
                </div>
                <h3 className="font-display text-2xl font-bold mt-6">{s.title}</h3>
                <p className="mt-3 text-[#6b6873] leading-relaxed">{s.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
